import type { FC } from 'react'

import { LoaderCircle, Table } from '@skytech/ui'
import { getWhiteLabelForDealerStyle } from '@skytech/utils'

import { useAppContext } from '@/App.context'
import { Translation } from '@/components/i18n/Translation'
import Error from '@/components/util/feedback/Error'
import NoResults from '@/components/util/NoResults'
import useRenderLimit from '@/hooks/render-limit-hook'

import { useInjuryReportsList } from '../hooks'

import InjuryReportListItem from './InjuryReportListItem'

const LIST_RENDER_LIMIT = 40

const InjuryReportList: FC = () => {
  const { whiteLabel } = useAppContext()
  const { list, isLoading, error } = useInjuryReportsList()
  const { visibleList, ListLoaderComponent } = useRenderLimit(list, LIST_RENDER_LIMIT)

  if (isLoading) return <LoaderCircle whiteLabel={getWhiteLabelForDealerStyle(whiteLabel)} />

  return (
    <>
      {error && <Error textId="Could not load injury reports" />}

      <Table rowHeight="tall" className="device-order-list">
        <>
          {list.length > 0 && (
            <thead>
              <tr>
                <th className="center">
                  <Translation id="id" />
                </th>
                <th>
                  <Translation id="user" />
                </th>
                <th>
                  <Translation id="status" />
                </th>
                <th>
                  <Translation id="asset" />
                </th>
                <th>
                  <Translation id="injury date" />
                </th>
                <th>
                  <Translation id="created date" />
                </th>
              </tr>
            </thead>
          )}

          <tbody>
            {visibleList.map(order => (
              <InjuryReportListItem key={order.id} {...order} />
            ))}
          </tbody>
        </>
      </Table>

      {list.length === 0 && <NoResults />}

      <ListLoaderComponent />
    </>
  )
}

export default InjuryReportList
